export * from './shhswh.component';